import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { CruiseContentSections } from 'constants/cruise'
import cn from 'clsx'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import FormatCurrency from 'components/Common/FormatCurrency'
import TextButton from 'components/Luxkit/Button/TextButton'
import Caption from 'components/Luxkit/Typography/Caption'
import Heading from 'components/Luxkit/Typography/Heading'
import Pill from 'components/Luxkit/Pill'
import Group from 'components/utils/Group'

const PriceSummarySection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  > * + * {
    margin-left: ${rem(12)};
  }

`

const PriceSummary = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;

  &.header {
    ${mediaQueryUp.sm} {
      text-align: right;
    }
  }
`

export interface PriceRoomTypeProps {
  onView: (ref: string) => void;
  priceFrom: App.CruisePriceDetails;
  header?: boolean;
}

function CruisePriceRoomTypeInfo({ onView, priceFrom, header = false }: PriceRoomTypeProps): JSX.Element {
  return (
    <PriceSummarySection>
      <PriceSummary className={cn({ header })}>
        <VerticalSpacer gap={4}>

          <Group direction="horizontal" gap={4}>
            <Caption variant="large" colour="neutral-two">from </Caption>
            <Heading variant="heading6">
              <FormatCurrency
                value={priceFrom.total}
                currency={priceFrom.currencyCode ?? 'AUD'}
              />
            </Heading>
            <Caption variant="large" colour="neutral-two">/person</Caption>
          </Group>
          <Caption variant="large" colour="neutral-three">Twin share </Caption>

          {!header && priceFrom.discountPills?.discountPercentage && (
            <Pill
              kind="primary"
              variant="success"
            >
              Save up to {priceFrom.discountPills.discountPercentage}%
            </Pill>
          )}
        </VerticalSpacer>
      </PriceSummary>

      <TextButton kind="primary" onClick={() => onView(CruiseContentSections.DEPARTURES)}>
        Check Availability
      </TextButton>
    </PriceSummarySection>
  )
}

export default CruisePriceRoomTypeInfo
